import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { Button } from './Button';
import { ROLE_OPTIONS } from '../data/site';
interface GatedDownloadModalProps {
  open: boolean;
  resourceTitle: string;
  onClose: () => void;
}
export function GatedDownloadModal({
  open,
  resourceTitle,
  onClose
}: GatedDownloadModalProps) {
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    if (open) setSubmitted(false);
  }, [open, resourceTitle]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    console.log('resource_download_started', {
      resource: resourceTitle
    });
    setSubmitted(true);
    // eslint-disable-next-line no-console
    console.log('resource_download_completed', {
      resource: resourceTitle
    });
    // eslint-disable-next-line no-console
    console.log('field_notes_signup', {
      source: 'gated_modal'
    });
  };
  return <AnimatePresence data-id="element-70">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4" data-id="element-71">
          <motion.div className="absolute inset-0 bg-charcoal/50" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} aria-hidden data-id="element-72" />
          <motion.div role="dialog" aria-modal="true" aria-label={`Download ${resourceTitle}`} className="relative z-10 w-full max-w-lg rounded-t-2xl bg-cream p-6 sm:rounded-2xl sm:p-8" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 30
      }} transition={{
        type: 'tween',
        duration: 0.25
      }} data-id="element-73">
            <button type="button" onClick={onClose} aria-label="Close" className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center rounded-md text-charcoal/60 hover:bg-charcoal/5 hover:text-charcoal" data-id="element-74">
              <XIcon className="h-5 w-5" data-id="element-75" />
            </button>

            {submitted ? <div className="py-4 text-center" data-id="element-76">
                <CheckCircle2Icon className="mx-auto h-12 w-12 text-improvements" data-id="element-77" />
                <h2 className="mt-4 text-xl font-black text-charcoal" data-id="element-78">
                  Thanks — it's on its way
                </h2>
                <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-warmgray" data-id="element-79">
                  Your resource is on its way. You'll also receive practical MGS
                  Field Notes when new resources and case studies are published.
                </p>
                <Button variant="secondary" onClick={onClose} className="mt-6" data-id="element-80">
                  Close
                </Button>
              </div> : <>
                <p className="text-xs font-bold uppercase tracking-widest text-decisions" data-id="element-81">
                  Free resource
                </p>
                <h2 className="mt-2 text-2xl font-black leading-tight text-charcoal" data-id="element-82">
                  {resourceTitle}
                </h2>
                <p className="mt-2 text-sm text-warmgray" data-id="element-83">
                  Tell us where to send it. No spam — practical field notes
                  only.
                </p>

                <form onSubmit={handleSubmit} className="mt-5 space-y-4" data-id="element-84">
                  <div className="grid gap-4 sm:grid-cols-2" data-id="element-85">
                    <Field label="Name" id="g-name" data-id="element-86">
                      <input id="g-name" required className="mgs-input" placeholder="Your name" data-id="element-87" />
                    </Field>
                    <Field label="Email" id="g-email" data-id="element-88">
                      <input id="g-email" type="email" required className="mgs-input" placeholder="you@example.com" data-id="element-89" />
                    </Field>
                  </div>
                  <Field label="Title" id="g-role" data-id="element-90">
                    <select id="g-role" required className="mgs-input" data-id="element-91">
                      <option value="" data-id="element-92">Select your title…</option>
                      {ROLE_OPTIONS.map(r => <option key={r} data-id="element-93">{r}</option>)}
                    </select>
                  </Field>
                  <Field label="What is the biggest challenge in your mine geology system right now? (optional)" id="g-challenge" data-id="element-94">
                    <textarea id="g-challenge" rows={3} className="mgs-input resize-none" placeholder="Tell us what's holding your system back…" data-id="element-95" />
                  </Field>
                  <label className="flex items-start gap-2.5 text-sm text-warmgray" data-id="element-96">
                    <input type="checkbox" defaultChecked className="mt-1 h-4 w-4 accent-charcoal" data-id="element-97" />
                    <span data-id="element-98">
                      Send me MGS Field Notes — practical resources and case
                      studies.
                    </span>
                  </label>
                  <Button type="submit" variant="primary" className="w-full" data-id="element-99">
                    Download the Toolkit
                  </Button>
                </form>
              </>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}
function Field({
  label,
  id,
  children
}: {
  label: string;
  id: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-100">
      <label htmlFor={id} className="mb-1.5 block text-xs font-semibold text-charcoal" data-id="element-101">
        {label}
      </label>
      {children}
    </div>;
}